
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $44154f2294040c10$exports = {};

$parcel$export($44154f2294040c10$exports, "focus-ring", function () { return $44154f2294040c10$export$f39a09f249340e2a; }, function (v) { return $44154f2294040c10$export$f39a09f249340e2a = v; });
$parcel$export($44154f2294040c10$exports, "i18nFontFamily", function () { return $44154f2294040c10$export$8c4ee2c50c22c514; }, function (v) { return $44154f2294040c10$export$8c4ee2c50c22c514 = v; });
$parcel$export($44154f2294040c10$exports, "spectrum", function () { return $44154f2294040c10$export$3311ab3a441bc141; }, function (v) { return $44154f2294040c10$export$3311ab3a441bc141 = v; });
$parcel$export($44154f2294040c10$exports, "spectrum-FocusRing-ring", function () { return $44154f2294040c10$export$4109102f950813a6; }, function (v) { return $44154f2294040c10$export$4109102f950813a6 = v; });
$parcel$export($44154f2294040c10$exports, "spectrum-FocusRing", function () { return $44154f2294040c10$export$24c7f46a6e3605dd; }, function (v) { return $44154f2294040c10$export$24c7f46a6e3605dd = v; });
$parcel$export($44154f2294040c10$exports, "spectrum-FocusRing--quiet", function () { return $44154f2294040c10$export$2927016961429360; }, function (v) { return $44154f2294040c10$export$2927016961429360 = v; });
var $44154f2294040c10$export$f39a09f249340e2a;
var $44154f2294040c10$export$8c4ee2c50c22c514;
var $44154f2294040c10$export$3311ab3a441bc141;
var $44154f2294040c10$export$4109102f950813a6;
var $44154f2294040c10$export$24c7f46a6e3605dd;
var $44154f2294040c10$export$2927016961429360;
$44154f2294040c10$export$f39a09f249340e2a = `_t8qIa_focus-ring`;
$44154f2294040c10$export$8c4ee2c50c22c514 = `_t8qIa_i18nFontFamily`;
$44154f2294040c10$export$3311ab3a441bc141 = `_t8qIa_spectrum`;
$44154f2294040c10$export$4109102f950813a6 = `_t8qIa_spectrum-FocusRing-ring`;
$44154f2294040c10$export$24c7f46a6e3605dd = `_t8qIa_spectrum-FocusRing ${$44154f2294040c10$export$4109102f950813a6}`;
$44154f2294040c10$export$2927016961429360 = `_t8qIa_spectrum-FocusRing--quiet`;


export {$44154f2294040c10$exports as default};
//# sourceMappingURL=page_vars_css.mjs.map
